export default "__VITE_ASSET__ZXYk6BRn__"